<script>
	import analyticsUtilities from 'utilities/analyticsUtilities';

	export default {
		props: {
			panels: {
				type: Array,
				required: true
			},
			headerText: {
				type: String
			},
			contentText: {
				type: String
			}
		},
		methods: {
			homepageClick(panel) {
				analyticsUtilities.fireEvent(analyticsUtilities.events.HOMEPAGE_CLICK, {
					loc: 'featured-content-card',
					path: panel.link
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'mixins/media';

	.featured-content-panel {
		padding: 1.5rem 0;
		position: relative;
		color: $c-white;
		z-index: 0;

		&::before {
			content: '';
			position: absolute;
			top: -1px;
			left: 0;
			width: 100%;
			height: 40%;
			min-height: 25rem;
			background: linear-gradient(90deg, $c-blue-accent-5 10%, $c-blue-accent-6 90%);
			z-index: -1;
		}

		h2 {
			text-align: center;
			margin: 0 0 2rem;
		}

		.panel-content {
			text-align: center;
		}

		.features {
			margin-top: 3rem;
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(20%, 9rem));
			grid-auto-rows: 1fr;
			gap: 1rem;
			justify-content: center;

			@include media(med) {
				gap: 2rem;
				grid-template-columns: repeat(4, 1fr);
			}
		}

		.feature-card {
			display: flex;
			flex-direction: column;
			height: 100%;
			border-radius: 1.5rem;
			overflow: hidden;
		}

		.feature-image {
			background-color: $c-babyblue;
			width: 100%;
			height: 8.5rem;
			object-fit: cover;

			@include media(med) {
				height: 11rem;
			}

			@include media(lg) {
				height: 14rem;
			}
		}

		.feature-card-info {
			flex: 1 0 4rem;
			display: flex;
			align-items: center;
			padding: 0.5rem 1rem;
			font-weight: 500;

			@include media(lg) {
				flex-basis: 5rem;
				font-size: 1.25rem;
				padding: 0.5rem 1.5rem;
			}
		}
	}
</style>
<template>
	<section
		class="featured-content-panel"
		:hidden="!panels || panels.length === 0">
		<div class="wrapper">
			<h2 v-if="headerText">{{ headerText }}</h2>
			<div
				v-if="contentText"
				class="panel-content">
				{{ contentText }}
			</div>
			<ul class="features list-unstyled">
				<li
					v-for="panel in panels"
					:key="panel.panel_link"
					class="feature">
					<a
						class="feature-card panel-card panel-action"
						:href="panel.panel_link"
						@click="homepageClick(panel)">
						<img
							class="feature-image"
							loading="lazy"
							:src="panel.image.url"
							:alt="panel.image.alt_text" />
						<div class="feature-card-info">{{ panel.content_text }}</div>
					</a>
				</li>
			</ul>
		</div>
	</section>
</template>
